import { render, staticRenderFns } from "./billing-modal-invoices-crud-actions.vue?vue&type=template&id=1665637c&"
import script from "./billing-modal-invoices-crud-actions.ts?vue&type=script&lang=ts&"
export * from "./billing-modal-invoices-crud-actions.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports